var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#95c675",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.28,24.46,53,15.9V9a2,2,0,0,0-4,0v3.56L35.84,1.6a6,6,0,0,0-7.68,0L.72,24.46a2,2,0,0,0,2.56,3.08L30.72,4.67a2,2,0,0,1,2.56,0L56,23.6V58a2,2,0,0,1-2,2H44V38a6,6,0,0,0-6-6H26a6,6,0,0,0-6,6V60H10a2,2,0,0,1-2-2V34a2,2,0,0,0-4,0V58a6,6,0,0,0,6,6H54a6,6,0,0,0,6-6V26.94l.72.6A2,2,0,0,0,62,28a2,2,0,0,0,1.28-3.54ZM24,60V38a2,2,0,0,1,2-2H38a2,2,0,0,1,2,2V60Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 48,
    r: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.320ff4c94da50a42a31861b39b9c71ad.svg";
export { ForwardRef as ReactComponent };